// extracted by mini-css-extract-plugin
export default {"container":"InfoBadge_container__GWrOq","icon":"InfoBadge_icon__ONauf","text":"InfoBadge_text__JGuhQ"};